class Filter {
  constructor({
    label,
    key,
    color,
    value,
    category,
    isVisible,
    type,
    min,
    max,
    filters,
    defaultVal,
    totalCount,
    helpText,
    options,
    nestId,
    disableCategoryNum,
    helpTextAnchor,
  }) {
    this.id = `${category}-${key}`;
    this.value = value || 0;
    this.label = label;
    this.nestId = nestId || label;
    this.helpText = helpText || null;
    this.helpTextAnchor = helpTextAnchor || null;
    this.totalCount = totalCount === null ? null : totalCount || 0;
    this.key = key;
    this.color = color;
    this.category = category;
    this.isVisible = isVisible;
    this.filters = filters || [];
    this.type = type || "checkbox";
    this.min = min || -Infinity;
    this.max = max || -Infinity;
    this.default = defaultVal || 0;
    this.step = 0.01;
    this.options = options || [];
    this.disableCategoryNum = Boolean(disableCategoryNum);
  }

  setColor(color) {
    this.color = color;
    return this;
  }

  setVisibleCount(visibleCount) {
    this.visibleCount = visibleCount;
    return this;
  }

  setTotalCount(count) {
    this.totalCount = count;
    return this;
  }

  setValue(value) {
    this.value = value;
    return this;
  }
}

export default Filter;
